import { TStatus } from '@/types/status.types';

export type TStatusColor = 'neutral' | 'success' | 'error' | 'pending' | 'info' | 'pending';

export const statusColors = {
  AUTHORIZED: 'success',
  SETTLED: 'success',
  VALIDATED: 'success',
  DELIVERED: 'neutral',
  PENDING: 'pending',
  NONE: 'neutral',
  LIGHT: 'neutral',
  REGULAR: 'success',
  STRONG: 'success',
  IN_PROGRESS: 'neutral',
  COMPLETE_WITH_ERROR: 'success',
  CANCELED: 'error',
  MINOR: 'neutral',
  ACTIVATED: 'success',
  DEACTIVATED: 'error',
  CREATING: 'pending',
  CREATED: 'pending',
  INITIALIZING: 'pending',
  ACTIVE: 'success',
  DELETED: 'error',
  LOCKED: 'error',
  REFUSED: 'error',
  COMPLETE: 'success',
  INVESTIGATING: 'pending',
  RUNNING: 'neutral',
  PASSCODE_MISSING: 'pending',
  DECLINED: 'neutral',
  SUSPENDED: 'pending',
  UNMAPPED: 'neutral',
  CLOSED: 'error',
  REVIEW_PENDING: 'pending',
  REVIEW_OPEN: 'neutral',
  INACTIVE: 'pending',
} as const;

export type TStatusColorKey = keyof typeof statusColors;

export const getStatusByLabel = (label?: TStatusColorKey): TStatus => {
  if (!label) return 'neutral';
  return statusColors[label] ?? 'neutral';
};
